import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ebc14a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "u-fold" }
const _hoisted_2 = { class: "action-box select-none" }

import { computed, onMounted, onUnmounted, ref } from 'vue'

interface Props {
  line?: number | string
  unfold?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'fold',
  props: {
    line: { default: 5 },
    unfold: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { line: number | string, unfold?: boolean }

_useCssVars(_ctx => ({
  "244ac654": (_unref(line))
}))


const line = computed(() => {
  let line = Math.trunc(Number(props.line))
  return line > 0 ? line : 1
})

// 文本是否是展开状态 默认为收起
const fold = ref(true)
//文本是否超出五行，默认否
const isOver = ref(false)

const divBox = ref<HTMLDivElement>()

let observer: ResizeObserver

onMounted(() => {
  observer = new ResizeObserver(entry => {
    if (fold.value && divBox.value) {
      //offsetHeight：包括内容可见部分的高度，border，可见的padding，水平方向的scrollbar（如果存在）；不包括margin。
      // clientHeight：包括内容可见部分的高度，可见的padding；不包括border，水平方向的scrollbar，margin。
      //scrollHeight：包括内容的高度（可见与不可见），padding（可见与不可见）；不包括border，margin。
      isOver.value = divBox.value.offsetHeight < divBox.value.scrollHeight
    }
  })

  observer.observe(divBox.value as any)
})

onUnmounted(() => {
  observer.disconnect()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["txt-box", { 'over-hidden': fold.value }])
    }, [
      _createElementVNode("div", {
        ref_key: "divBox",
        ref: divBox
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 512)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      (isOver.value && __props.unfold)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "expand-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (fold.value = !fold.value))
          }, _toDisplayString(fold.value ? '展开' : '收起'), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})